import axios from "axios";
import Keycloak from "keycloak-js";
import ConstantsList from "../appConfig";
import JwtAuthService from "./jwtAuthService";

const _kc = new Keycloak(ConstantsList.ROOT_PATH + "keycloak.json");

/**
 * Initializes Keycloak instance and calls the provided callback function if successfully authenticated.
 *
 * @param onAuthenticatedCallback
 */

const initKeycloak = (onAuthenticatedCallback) => {
  _kc
    .init({
      onLoad: "check-sso",
      promiseType: "native",
      silentCheckSsoRedirectUri:
        window.location.origin + "/silent-check-sso.html",
      pkceMethod: "S256",
      checkLoginIframe: false,
    })
    .then((authenticated) => {
      if (authenticated) {
        JwtAuthService.setLoginToken(_kc.token); //Xem lại hàm này để làm chuẩn xác hơn
        onAuthenticatedCallback();

        if (window.location.hash.includes("iss=")) {
          window.history.replaceState(
            null,
            "",
            window.location.pathname + window.location.search
          );
        }
      } else {
        // console.warn("not authenticated!");
        // doLogin();
        updateToken(() => {
          axios.defaults.headers.common[
            "Authorization"
          ] = `Bearer ${getToken()}`;
        });
      }
    });
};

const doLogin = _kc.login;

const doLogout = () => {
  let logoutOptions = {
    redirectUri: window.location.origin,
  };
  _kc.logout(logoutOptions);
};

const getToken = () => _kc.token;

const updateToken = (successCallback) => {
  // alert("update");
  return _kc.updateToken(5).then(successCallback).catch(doLogin);
};

const getUsername = () => _kc.tokenParsed.preferred_username;

export default {
  initKeycloak,
  doLogin,
  doLogout,
  getToken,
  updateToken,
  getUsername,
};
